module.exports = __webpack_public_path__ + "static/media/phone3.b34fdc49.png";